import PlanProgressRepository from '../../domain/repositories/PlanProgressRepository';
import PlanProgresDataStore from '../datastores/PlanProgressDataStore';
import PlanProgressDataStoreFactory from '../factories/PlanProgressDataStoreFactory';

export default class PlanProgressDataRepository
  implements PlanProgressRepository
{
  getPlanProgressDetail(acadPlan: string, prog: string, career: string) {
    const planProgressDataStore: PlanProgresDataStore =
      PlanProgressDataStoreFactory.create();
    return planProgressDataStore.getPlanProgressDetail(acadPlan, prog, career);
  }

  getPlanProgressEquivalences(courseId: string, courseList: string[]) {
    const planProgressDataStore: PlanProgresDataStore =
      PlanProgressDataStoreFactory.create();
    return planProgressDataStore.getPlanProgressEquivalences(
      courseId,
      courseList
    );
  }

  getPlanProgressResume(acadPlan: string, prog: string) {
    const planProgressDataStore: PlanProgresDataStore =
      PlanProgressDataStoreFactory.create();
    return planProgressDataStore.getPlanProgressResume(acadPlan, prog);
  }

  getPlanProgressPS(plan: string, prog: string) {
    const planProgressDataStore: PlanProgresDataStore =
      PlanProgressDataStoreFactory.create();
    return planProgressDataStore.getPlanProgressPS(plan, prog);
  }
}
